module.exports = __webpack_public_path__ + "img/timeline_handschrift_anim.6c1f2766.png";